type TProps = {
  open?: boolean;
  dark?: boolean;
};

export const Logo = ({ open, dark }: TProps) => {
  const fillColor = dark ? '#5B31AA' : 'white';
  return (
    <>
      {open ? (
        <svg
          width='94'
          height='24'
          viewBox='0 0 94 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M91.0944 23.587V22.4148H90.6948V22.2117H91.7471V22.4148H91.3442V23.587H91.0944Z'
            fill={fillColor}
          />
          <path
            d='M91.9868 23.5868V22.2148H92.2865L92.7228 23.084L93.1557 22.2148H93.4554V23.5868H93.2056V22.6411L92.8227 23.3937H92.6262L92.2432 22.6411V23.5868H91.9868Z'
            fill={fillColor}
          />
          <path
            d='M3.64312 9.59072H8.45843V6.52703H3.64312V2.48096H0V18.0158C0 20.1038 0.492855 21.5524 1.47856 22.3649C2.46427 23.1775 3.79297 23.5838 5.46801 23.5838H8.46177V20.4901H3.64646V9.59072H3.64312Z'
            fill={fillColor}
          />
          <path
            d='M21.0863 17.303L14.8024 23.5869H9.64746L18.1792 15.0552L9.65079 6.52686H14.8058L21.0863 12.8074C22.3251 14.0495 22.3251 16.0609 21.0863 17.303Z'
            fill='#FD8100'
          />
          <path
            d='M41.6426 23.5871V2.48096H45.289V23.5871H41.6426Z'
            fill={fillColor}
          />
          <path
            d='M78.2435 17.3033L84.5274 23.5872H89.6824L81.1507 15.0555L89.6791 6.5271H84.5241L78.2435 12.8076C77.0048 14.0498 77.0048 16.0612 78.2435 17.3033Z'
            fill={fillColor}
          />
          <path
            d='M72.749 2.48096V23.5871H76.3955V2.48096H72.749Z'
            fill={fillColor}
          />
          <path
            d='M48.8125 23.587V6.53027H52.4589V23.587H48.8125Z'
            fill={fillColor}
          />
          <path
            d='M50.6372 4.96183C52.0073 4.96183 53.1181 3.85108 53.1181 2.4809C53.1181 1.11073 52.0073 0 50.6372 0C49.267 0 48.1562 1.11073 48.1562 2.4809C48.1562 3.85108 49.267 4.96183 50.6372 4.96183Z'
            fill={fillColor}
          />
          <path
            d='M36.581 19.1681L38.7955 21.3792V21.3826C37.1771 23.001 34.9426 24 32.475 24C27.5365 24 23.5337 19.9972 23.5337 15.0587C23.5337 10.1235 27.5365 6.11743 32.475 6.11743C34.9426 6.11743 37.1804 7.11646 38.7955 8.73821L36.581 10.9527C35.5287 9.9004 34.0768 9.25104 32.475 9.25104C29.2648 9.25104 26.6607 11.8518 26.6607 15.0621C26.6607 18.2723 29.2615 20.8764 32.475 20.8764C34.0768 20.8731 35.5287 20.2204 36.581 19.1681Z'
            fill={fillColor}
          />
          <path
            d='M68.1503 19.1681L70.3648 21.3792V21.3826C68.7464 23.001 66.5119 24 64.0443 24C59.1058 24 55.103 19.9972 55.103 15.0587C55.103 10.1235 59.1058 6.11743 64.0443 6.11743C66.5119 6.11743 68.7498 7.11646 70.3648 8.73821L68.1503 10.9527C67.098 9.9004 65.6461 9.25104 64.0443 9.25104C60.8341 9.25104 58.23 11.8518 58.23 15.0621C58.23 18.2723 60.8308 20.8764 64.0443 20.8764C65.6494 20.8731 67.1014 20.2204 68.1503 19.1681Z'
            fill={fillColor}
          />
        </svg>
      ) : (
        <svg
          width='22'
          height='22'
          viewBox='0 0 22 22'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3.63531 7.55654H8.45062V4.49285H3.63531V0.446777H-0.0078125V15.9817C-0.0078125 18.0696 0.485042 19.5182 1.47075 20.3308C2.45646 21.1433 3.78516 21.5496 5.46019 21.5496H8.45395V18.4559H3.63864V7.55654H3.63531Z'
            fill='white'
          />
          <path
            d='M21.0785 15.2689L14.7946 21.5527H9.63965L18.1714 13.021L9.64298 4.49268H14.798L21.0785 10.7732C22.3173 12.0154 22.3173 14.0267 21.0785 15.2689Z'
            fill='#FD8100'
          />
        </svg>
      )}
    </>
  );
};
